import axios from "axios";
import { API_URL } from "@/config";
import downloadFile from "@/utils/downloadFile";
import printFile from "@/utils/printFile";

export default {
  namespaced: true,

  actions: {
    async getMany(_, criteria) {
      const response = await axios.get(`${API_URL}/mealsMenusFiles`, { params: criteria });

      if (!response.data || typeof response.data.items !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async getOne(_, mealsMenuFileId) {
      const response = await axios.get(`${API_URL}/mealsMenusFiles/${mealsMenuFileId}`);

      if (!response.data || typeof response.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async create(_, formData) {
      const response = await axios.post(`${API_URL}/mealsMenusFiles`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status !== 201 || !response.data || typeof response.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async update(_, { mealsMenuFileId, formData }) {
      const response = await axios.post(`${API_URL}/mealsMenusFiles/${mealsMenuFileId}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status !== 200 || !response.data || typeof response.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async delete(_, mealsMenuFileId) {
      const response = await axios.delete(`${API_URL}/mealsMenusFiles/${mealsMenuFileId}`);

      if (response.status !== 200 || !response.data.status) {
        throw new Error("Error occurred while processing your request.");
      }

      return true;
    },

    async download(_, { mealsMenuFileId }) {
      const response = await axios({
        url: `${API_URL}/mealsMenusFiles/download/${mealsMenuFileId}`,
        method: "GET",
        responseType: "blob",
      });

      if (response.status !== 200) {
        throw new Error("Error occurred while processing your request.");
      }

      downloadFile(response);

      return true;
    },

    async show(_, mealsMenuFileId) {
      const response = await axios({
        url: `${API_URL}/mealsMenusFiles/download/${mealsMenuFileId}`,
        method: "GET",
        responseType: "blob",
      });

      if (response.status !== 200) {
        throw new Error("Error occurred while processing your request.");
      }

      window.open(URL.createObjectURL(response.data), "_blank");

      return true;
    },

    async print(_, mealsMenuFileId) {
      const response = await axios({
        url: `${API_URL}/mealsMenusFiles/download/${mealsMenuFileId}`,
        method: "GET",
        responseType: "blob",
      });

      if (response.status !== 200) {
        throw new Error("Error occurred while processing your request.");
      }

      printFile(response);

      return true;
    },
  },
};
